export * from './base-tms.module';
export * from './config/index';
export * from './model/index';
export * from './services/index';

/** AUGMENTABLE_TYPES_START */
export { TmsCollectors } from './config/tms-config';
/** AUGMENTABLE_TYPES_END */
